module.exports = __webpack_public_path__ + "img/part-3-title.347f8bf5.png";